import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { authenticatedRoute } from '@/app/routes/authenticated'

export const accountRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/account',
  component: lazyRouteComponent(() => import('./pages/account-page'), 'AccountPage'),
})
